import React from 'react';
import { CSSObject } from '@chakra-ui/react';
import { TBetReturn } from '../HeaderRow.types';
import IconSvg from '@/components/common/IconSvg';
import { HeaderRowSchema } from './HeaderRow.styles';

export const RunnerDetails: CSSObject = {
  color: 'white',
  fontWeight: 'extrabold',
};
export const RunnerDescription: CSSObject = {
  color: 'gamma.400',
  fontSize: 'xs',
  fontWeight: 'bold',
  'span:nth-child(2)': {
    color: 'rgba(255, 255, 255, 0.24)',
  },
};
export const BetOdds: CSSObject = {
  color: 'white',
};
export const TextBarrierNumber: CSSObject = {
  color: 'white',
  fontSize: '2xs',
  fontWeight: 'medium',
};
export const BetReturn = (status: TBetReturn): CSSObject => ({
  label: status,
  bg: () => {
    switch (status) {
      case 'won':
        return 'green.500';
      case 'pending':
        return 'orange.600';
      default:
        return 'gamma.400';
    }
  },
  color: () => {
    switch (status) {
      case 'won':
        return 'white';
      case 'pending':
        return 'orange.200';
      default:
        return 'blackAlpha.700';
    }
  },
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  py: '0',
});
export const HeaderSvg: CSSObject = {
  filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
  boxSize: '5',
};
export const BetMultiIcon: CSSObject = {
  boxSize: '5',
};
export const MultiIcon = () => (
  <IconSvg
    name="multi_betslip"
    className="svgIcon"
    color="gamma.300"
    boxSize="5"
    mb="1.5"
  />
);
export const TextDescription: CSSObject = {
  textTransform: 'capitalize',
};
export const headerRowStyles: HeaderRowSchema = {
  originalOdds: {
    color: 'gray.100',
  },
  headerRowSvg: {
    fill: 'rgba(99,59,206,255)',
  },
};
